import { Component, Prop, h } from '@stencil/core';

import { VehicleOption } from '../../../interfaces/interface.vehicle';

@Component({
  tag: 'changed-options-modal',
  styleUrl: 'changed-options-modal.css',
})
export class ChangedOptionsModal {
  @Prop() lastInteractedOption: VehicleOption = {} as VehicleOption;
  @Prop() options: VehicleOption[] = [];

  renderOption(option: VehicleOption) {
    const operator = option.isSelected ? '+' : <span>&ndash;</span>;
    return (
      <li
        class={{
          'list-none mb-1 text-sm': true,
          'text-clrs-ico-darkred': !option.isSelected,
          'text-clrs-green': option.isSelected,
        }}>
        <span class="inline-block mr-1">{operator}</span> {option.displayName}
      </li>
    );
  }

  render() {
    return (
      <ico-modal displayX id="changed-options-modal">
        <div slot="header">
          <h2 class="ico-components-heading mb-3">One or more options have changed.</h2>
          <div class="mb-3 text-sm">When you made a new selection, certain options replaced other options. Or sometimes options can't be chosen together.</div>
        </div>
        <h3 class="mb-2 text-lg font-bold text-ico-heading">Option(s) selected:</h3>
        <div class="mb-8">{this.renderOption(this.lastInteractedOption)}</div>
        <h3 class="mb-2 text-lg font-bold text-ico-heading">Option(s) that changed:</h3>
        <ul class="p-0">
          {this.options.map((option) => {
            if (option.wasChangedBySystem) {
              return this.renderOption(option);
            }
          })}
        </ul>
      </ico-modal>
    );
  }
}
